"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
/**
 * Accordion component
 */
class Accordion extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            const { items } = this.props;
            const opened = items.reduce((p, c, i) => {
                if (c.expanded)
                    return [...p, i];
                return p;
            }, []);
            setTimeout(() => this.setState({
                opened,
            }), 100);
        };
        this.setTextRef = (e, i) => {
            this.textsRefs[i] = e;
        };
        this.toggleItem = (index) => {
            const { singleOpen: single } = this.props;
            const { opened } = this.state;
            let newOpened = [...opened];
            if (single)
                return this.setState({ opened: index === opened[0] ? [] : [index] });
            if (opened.includes(index)) {
                newOpened = newOpened.filter((i) => i !== index);
            }
            else {
                newOpened.push(index);
            }
            return this.setState({ opened: newOpened });
        };
        this.render = () => {
            const _a = this.props, { items, icons } = _a, rest = __rest(_a, ["items", "icons"]);
            const { opened } = this.state;
            return (react_1.default.createElement("div", Object.assign({}, rest), items.map((item, index) => {
                const openedIcon = item.icons ? item.icons.opened : icons === null || icons === void 0 ? void 0 : icons.opened;
                const closedIcon = item.icons ? item.icons.closed : icons === null || icons === void 0 ? void 0 : icons.closed;
                return (
                // eslint-disable-next-line react/no-array-index-key
                react_1.default.createElement(styled_1.Item, { key: index },
                    react_1.default.createElement(styled_1.Title, { type: "button", expanded: item.expanded || opened.includes(index), onClick: () => {
                            if (item.expanded)
                                return;
                            this.toggleItem(index);
                        } },
                        item.title,
                        opened.includes(index) ? openedIcon : closedIcon),
                    react_1.default.createElement(styled_1.Content, { expanded: item.expanded || opened.includes(index), style: {
                            height: opened.includes(index) && this.textsRefs[index]
                                ? this.textsRefs[index].offsetHeight
                                : 0,
                        } },
                        react_1.default.createElement(styled_1.Text, { ref: (e) => this.setTextRef(e, index) }, item.content))));
            })));
        };
        this.state = {
            opened: [],
        };
        this.textsRefs = [];
        this.toggleItem = this.toggleItem.bind(this);
        this.setTextRef = this.setTextRef.bind(this);
    }
}
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map